module.exports = __webpack_public_path__ + "static/hour_glass.7662608a.png";